import AbacusClientUtils from '@homeaway/abacus-client-utils';

function experimentIsValid(experimentName) {
    return (window !== 'undefined'
        && window.__ABACUS__
        && AbacusClientUtils.evaluateExperiment(experimentName));
}

function getExperimentValue(experimentName) {
    return experimentIsValid(experimentName) ? AbacusClientUtils.evaluateExperimentAndLog(experimentName).value : 0;
}

export {
    getExperimentValue
};
